import { CoreScreen } from "../screens/CoreScreen";
import { NoticeScreen } from "../screens/NoticeScreen";
import { AccountScreen } from "../screens/AccountScreen";
import { ListScreen } from "../screens/ListScreen";
import { SubscriptionsScreen } from "../screens/SubscriptionsScreen";
import { ChangeSubscriptionsScreen } from "../screens/ChangeSubscriptionsScreen";
import { ConfirmChangeScreen } from "../screens/ConfirmChangeScreen";
import { ConfirmCancelSubscriptionScreen } from "../screens/ConfirmCancelSubscriptionScreen";
import { AuthScreen } from "../screens/AuthScreen";
import { SubscribeAuthScreen } from "../screens/SubscribeAuthScreen";
import { OtpScreen } from "../screens/OtpScreen";

import type { SubscriptionActions } from "../screens/components/SubscriptionActions";
import type { SubscriptionChangeActions } from "../screens/components/SubscriptionChangeActions";

import type { Screen } from "../app/api/ApiClient";

import type { AppScreen } from "../screens/Screen";
import type { StateStore } from "../app/state/StateStore";

import type { BlockRegistry } from "../blocks/BlockRegistry";
import type { BlockServices } from "../blocks/BlockServices";

import type {ScreenEvents} from "../screens/ScreenEvents";



export class ScreenFactory {

    constructor(

        private readonly store: StateStore,

        private readonly blockRegistry: BlockRegistry,

        private readonly blockServices: BlockServices

    ) {}

    public create(

        screen: Screen,

        events: ScreenEvents,
        
        subscriptionActions: SubscriptionActions,

        subscriptionChangeActions: SubscriptionChangeActions


    ): AppScreen {

        switch (screen.type) {

            case "krok":

                return new CoreScreen(

                    this.store,

                    this.blockRegistry,

                    this.blockServices,

                    events.core

                );

            case "notice":

                return new NoticeScreen(

                    screen,

                    this.store,

                    events.header,

                    events.list.openKrok

                );

            case "auth":

                return new AuthScreen(

                    events.auth

                );

            case "subscribeAuth":

                return new SubscribeAuthScreen(

                    events.auth

                );

            case "otp":

                return new OtpScreen(

                    screen.email,

                    events.auth

                );    

            case "account":

                return new AccountScreen(

                    this.store,

                    events.header,

                    events.account

                );

            case "list":

                return new ListScreen(

                    screen,

                    this.store,

                    events.header,

                    events.list.openKrok

                );

            case "subscriptions":

                return new SubscriptionsScreen(

                    screen,

                    this.store,

                    events.header,

                    subscriptionActions

                );

            case "changeSubscriptions":

                return new ChangeSubscriptionsScreen(

                    screen,

                    this.store,

                    events.header,

                    subscriptionChangeActions

                );
                
            case "confirmChange":

                return new ConfirmChangeScreen(

                    screen,

                    this.store,

                    events.header,

                    subscriptionChangeActions

                );      

            case "confirmCancelSubscription":

                return new ConfirmCancelSubscriptionScreen(

                    this.store,

                    events.header,

                    events.account

                );  

            default:

                throw new Error(
                    `Unsupported screen type: ${screen.type}`
                );

        }

    }

}